
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["longtermProduct_svg__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1170 1024","xmlns":"http://www.w3.org/2000/svg","width":"146.25","height":"128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1170.286 365.714v554.277c0 57.417-46.592 104.009-104.01 104.009H104.01A104.01 104.01 0 010 919.99V365.715h1170.286zM988.233 475.43h-221.11V680.52c-.732 57.93-13.459 105.838-38.913 143.653l21.212 21.065c25.088-35.767 39.716-80.677 44.324-135.314h166.327v83.602c0 12.215-4.608 18.505-13.531 18.505-14.629 0-30.867-.878-48.567-1.682l7.68 29.842h49.737c21.65 0 32.914-12.215 32.914-36.133V475.43zm-728.137 211.31H104.009v52.808h156.087v-52.736zm699.977-80.604v75.556h-164.79v-75.556h164.79zm-517.998-25.088H104.01v52.882h338.066v-52.882zm517.998-76.654v73.582h-164.79v-73.582h164.79zM1066.277 0c57.417 0 104.009 46.592 104.009 104.01v115.419H0v-115.42C0 46.592 46.592 0 104.01 0h962.267z"}})])
          )
        }
      }
    